import { useEffect } from 'react';

import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { CreditWorthinessDialog } from './CreditWorthinessDialog';
import DialogBox from '~/components/DialogBox';
import Spinner from '~/components/icons/Spinner';
import { useOfferById } from '~/features/leadDetails/components/Overview/OfferManagement/hooks/useOfferById';

type Props = {
    leadId: string;
    offerId: string;
    onClose: () => void;
};

export const RouteCreditWorthinessDialog = ({ leadId, offerId, onClose }: Props) => {
    const { t } = useTranslation();
    const { data, isError, isPending, isSuccess } = useOfferById({ aggregateId: leadId, offerId });
    const isSupportedOffer =
        data?.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE ||
        data?.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC;

    useEffect(() => {
        if (isSuccess && !isSupportedOffer) onClose();
    }, [isSuccess, isSupportedOffer, onClose]);

    if (isPending) {
        return (
            <DialogBox
                dataTestId="creditWorthinessLoadingDialog"
                open
                title={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.TITLE')}
                onClose={onClose}
            >
                <Spinner />
            </DialogBox>
        );
    }

    if (isError) {
        return (
            <DialogBox
                dataTestId="creditWorthinessErrorDialog"
                open
                title={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.TITLE')}
                onClose={onClose}
            >
                <p>{t('errorPage.error')}</p>
            </DialogBox>
        );
    }

    if (!data || !isSupportedOffer) return null;

    return <CreditWorthinessDialog {...data} isOpen onClose={onClose} />;
};
